import { render, staticRenderFns } from "./summaryTiktok.vue?vue&type=template&id=3f61272f&scoped=true&"
import script from "./summaryTiktok.vue?vue&type=script&lang=js&"
export * from "./summaryTiktok.vue?vue&type=script&lang=js&"
import style0 from "./summaryTiktok.vue?vue&type=style&index=0&id=3f61272f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61272f",
  null
  
)

export default component.exports